import { Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ProjectsFacade,
  SharedFacade,
  debounce,
  delayedFunctionCall,
  formatNumber,
  getRolesAndPermission,
  noWhitespaceValidator,
  onKeyDown,
} from '@piqet-angular/data';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import {
  DistanceTypeEnum,
  StorageTypeEnum,
  commonEnum,
  mainModuleName,
  rolesModuleName,
} from 'libs/shared/src/lib/constants';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ProjectScenarioRetailDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-retail/project-scenario-retail-data-grid.service';
import { TitleCasePipe } from '@angular/common';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Observable, Subject, Subscription, first, forkJoin, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MapsAPILoader } from '@agm/core';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'piqet-angular-new-project-scenario-retail',
  templateUrl: './new-project-scenario-retail.component.html',
  styleUrls: ['./new-project-scenario-retail.component.scss'],
  providers: [TitleCasePipe],
})
export class NewProjectScenarioRetailComponent implements OnDestroy {
  pageNumber: number = 1;
  searchValue: any;
  selectedCities: any;
  StorageTypeEnum = StorageTypeEnum;
  modalLabel: any = 'Add retail';
  packageLevel: any;
  projectPackRetailForm!: FormGroup;
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  wholeData: any = [
    {
      displayName: 'Based on location',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportationId: 2,
    },
    {
      displayName: 'Based on distance',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportationId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportationId: 4,
    },
  ];
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  keywordAuto: string = '';
  selectedBox: any;
  isShowPort = false;
  isCustomTruck = false;
  keyword = 'name';
  originId: any;
  seaDistance: any;
  transportModeItems: any;
  transportModeId: any;
  transportModeName: any;
  transportModeDescription: any;
  customTruckItems: any;
  customtransportScenarioItems: any;
  transportationDetailForm: any;
  transportationId: any;
  isShowCustomTransportList = false;
  customTransportList: any;
  customTransportDef: any;
  customEolDef: any;
  isShowDistantField = false;
  packReatilData: any;
  processColumnDef: any;
  distanceProcessColumnDef: any;
  destinationData: any;
  setOriginsubmitted = false;
  setDestinationsubmitted = false;
  isCustomEndofLife = false;
  isCalcByPalletOrigin: any = false;
  isCalcByPallet = false;
  isCostTrunOff = false;
  transportScenarioData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    originId: '',
  };
  transportScenarioDataForDistance: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
  };
  setManualDistanceSubmitted = false;
  CustomtransportScenarioId: any;
  scenarioId: any;
  projectId: any;
  storageDetailForm: any;
  productDetailForm: any;
  eodDetailForm: any;
  isCustomStorage = false;
  storageIdentifierItems: any;
  customStorageItems: any;
  regionItems: any;
  finalSubmit: any;
  productLossWasteDisposalItems: any;
  endofLifeIdentifierItems: any;
  customWasteScenarioId: any;
  customwasteScenarioItems: any;
  customStorageData: any;
  storageCountryData: any;
  productLoassData: any;
  productAccociate: any;
  customWasteData: any;
  getResetEolList: any;
  customtransportScenarioData: any;
  rowValue: any;
  isEolTotal = false;
  eolGridName: any;
  pathName: any;
  transportHeader = '';
  maxLoad: any;
  messageType: any;
  isValidPort: any;
  lastItem: any;
  cityWithPort: any;
  isLoading = false;
  subscriptionInline!: Subscription;
  secondaryMarketDropdown: boolean = false;
  secondaryMarketStr = 'Sale to secondary market';

  secondaryMarketValueItem: any;
  secondaryDefaultValue: number = 10;
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  @Output() saveNewMyProjectPackRetailEvent = new EventEmitter<any>();
  checkIsOrginBtn = true;
  isCheckEditManudalDist = false;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  subscriptionProjectRetailData!: Subscription;
  projectRetaileditData: any;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProjectRetailManudalDistanceData!: Subscription;
  projectRetaileditManualDistanceData: any;
  setApiResDistance = false;
  setManualLocationDis: any;
  setManualLocationDisForNextRecord: any;
  customFreightSelectData: any;
  checkAddCustomFreight = false;
  subscriptionSaveProjectManualDistanceRetailData!: Subscription;
  clearInputFieldProjectRetailManualDistance!: Subscription;
  private searchSubject = new Subject<string>();
  isStorageProcessValue = false;
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  showEdit: boolean = false;

  showCustomTruckAccess: boolean = false;
  showCustomStorage: boolean = false;
  showCustomTransportAccess: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private sharedFacade: SharedFacade,
    public projectFacde: ProjectsFacade,
    private projectService: ProjectsService,
    private projectScenarioRetailDataGridService: ProjectScenarioRetailDataGridService,
    private route: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private customService: CustomService,
    private accessService: AccessPermissionService,
    private sharedService: SharedService,
    private toaster: ToastrService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.pathName = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.transportHeader =
      this.pathName == 'consumer-list' ? 'Transportation to consumer' : 'Transportation to retail';
    this.packReatilData =
      this.modal?.modalService?.config?.initialState?.['newMyProjectsPackRetail'];
    this.processColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualDestinationDataColumn();
    this.customEolDef = this.modal?.modalService?.config?.initialState?.['customEolDef'];
    this.customTransportDef =
      this.modal?.modalService?.config?.initialState?.['customTransportColumnDef'];
    this.transportModeItems = this.packReatilData.transportModeItems;
    this.customTruckItems = this.packReatilData.customTruckItems;
    this.customtransportScenarioItems = this.packReatilData.customtransportScenarioItems;
    this.CustomtransportScenarioId = this.packReatilData?.customtransportScenarioId;
    this.checkAddCustomFreight = !!this.CustomtransportScenarioId ? true : false;
    this.scenarioId = this.packReatilData.scenarioId;
    this.projectId = this.packReatilData.projectId;
    this.storageIdentifierItems = this.packReatilData.storageIdentifierItems;
    this.customStorageItems = this.packReatilData.customStorageItems;
    this.isCustomStorage = this.packReatilData.isCustomStorage;
    this.customTransportList = this.packReatilData?.customTransoportScenarioDetailViewModels;
    this.regionItems = this.packReatilData.regionItems;
    this.endofLifeIdentifierItems = this.packReatilData.endofLifeIdentifierItems;
    this.productLossWasteDisposalItems = this.packReatilData.productLossWasteDisposalItems;
    this.isCustomEndofLife = this.packReatilData.isCustomEndofLife;
    this.customwasteScenarioItems = this.packReatilData.customwasteScenarioItems;
    this.projectFacde.addEolViewModalData(this.packReatilData.eOLListViewModels);
    this.isCostTrunOff = !this.packReatilData.isCostTrunOff;
    this.secondaryMarketValueItem = this.packReatilData?.secondaryMarketvalueItem;
    this.isCustomStorage ? this.getCustomStorageName() : this.getStorageName();
    this.getStorageCountry();
    this.getProductLoss();
    this.getProductAccociate();
    this.getCustomWasteItem();
    !!this.CustomtransportScenarioId && this.customScenarioItem();
  }

  async fingOriginAndDestination(x: any) {
    this.getOriginAndDestinationEditData = x;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.transportationDetailForm.patchValue({ Origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.transportationDetailForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit(): void {
    const pathName = this.route.snapshot.routeConfig?.path;
    this.showCustomStorage = getRolesAndPermission(
      rolesModuleName.customStorage,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTruckAccess = getRolesAndPermission(
      rolesModuleName.customTrucks,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTransportAccess = getRolesAndPermission(
      rolesModuleName.customTransportScenario,
      mainModuleName.customModule
    )?.isOverview;
    this.showEdit = this.accessService.hasPermission('edit', pathName, 'packaging');
    this.projectFacde.getTransportScenarioListForRetail$.pipe(take(1)).subscribe((data: any) => {
      this.checkIsOrginBtn = false;
    });
    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });
    this.subscriptionCheckDeleteRowData =
      this.projectScenarioRetailDataGridService.checkDeleteRowRetailData$.subscribe(
        (check: any) => {
          this.transportationDetailForm.controls['Origin'].setValue(null);
          this.transportationDetailForm.controls['destination'].setValue(null);
          this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
          this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
          this.transportationDetailForm.controls['distance'].setValue('');
          this.transportationDetailForm.controls['palletLoad'].setValue(0);
          this.transportationDetailForm.controls['palletsInTruck'].setValue(0);
          this.transportationDetailForm.controls['loadInTruck'].setValue(0);
          this.transportationDetailForm.controls['percentLoaded'].setValue(0);

          this.transportationDetailForm.controls['palletLoadOrigin'].setValue(0);
          this.transportationDetailForm.controls['palletsInTruckOrigin'].setValue(0);
          this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(0);
          this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(0);
          check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
          this.isCheckUpdateDestination = false;
          this.isCalcByPallet = false;
          this.isCalcByPalletOrigin = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
        }
      );

    this.clearInputFieldProjectRetailManualDistance =
      this.projectScenarioRetailDataGridService.clearInputFieldProjectRetailManualDistanceData$.subscribe(
        (check: any) => {
          this.transportationDetailForm.controls['Origin'].setValue(null);
          this.transportationDetailForm.controls['destination'].setValue(null);
          this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
          this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
          this.transportationDetailForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );

    this.subscriptionProjectRetailManudalDistanceData =
      this.projectScenarioRetailDataGridService.editProjectRetailManualDistanceSubData$.subscribe(
        (editData: any) => {
          this.projectRetaileditManualDistanceData = editData;
          this.isCustomTruck = editData.isCustomTruck;
          this.isCalcByPallet = editData.isPalletLoad;
          this.transportModeId = editData.transportModeId;
          if (this.isCalcByPallet && this.isCustomTruck) {
            this.transportationDetailForm.controls['palletLoad'].setValue(editData.palletLoad);
            this.transportationDetailForm.controls['palletsInTruck'].setValue(
              editData.palletInTruck
            );
            this.transportationDetailForm.controls['loadInTruck'].setValue(editData.loadInTruck);
            this.transportationDetailForm.controls['percentLoaded'].setValue(
              editData.persanteageMassLoad
            );
          }
          this.isCheckEditManudalDist = true;
          this.transportationDetailForm.controls['distance'].setValue(editData.distance);
          const location = editData.isCustomTruck ? this.customTruckItems : this.transportModeItems;
          const locationId = editData.isCustomTruck
            ? editData.customTruckId
            : editData.transportModeId;
          location.map((x: any) => {
            if (x.id == locationId) {
              this.setDestinationLocationData = x;
              this.transportationDetailForm.patchValue({
                transportModeForDistance: this.setDestinationLocationData,
              });
            }
          });
        }
      );

    this.subscriptionProjectRetailData =
      this.projectScenarioRetailDataGridService.editProjectRetailSubData$.subscribe(
        async (editData: any) => {
          this.projectRetaileditData = editData[0];
          this.isCustomTruck = editData[0].isCustomTruck;
          this.isCalcByPalletOrigin = editData[0].isPalletLoad;
          this.transportModeId = editData[0].transportModeId;
          if (this.isCalcByPalletOrigin && this.isCustomTruck) {
            this.transportationDetailForm.controls['palletLoadOrigin'].setValue(
              editData[0].palletLoad
            );
            this.transportationDetailForm.controls['palletsInTruckOrigin'].setValue(
              editData[0].palletInTruck
            );
            this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(
              editData[0].loadInTruck
            );
            this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(
              editData[0].persanteageMassLoad
            );
          }
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.transportationDetailForm.controls['distanceManulaLocation'].setValue(
            distanceManualLocationvalue
          );
          if (editData[1]) {
            this.projectFacde.getTransportScenarioListForRetail$
              .pipe(take(1))
              .subscribe(async (data: any) => {
                this.checkIsOrginBtn = data.length <= 1 ? true : false;
              });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].originName;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.customTruckItems
              : this.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                this.transportationDetailForm.patchValue({
                  transportModeForLocation: this.setDestinationLocationData,
                });
              }
            });
          }
        }
      );
    this.subscriptionSaveProjectManualDistanceRetailData =
      this.projectScenarioRetailDataGridService.saveProjectManualDistanceRetailData$.subscribe(
        (editData: any) => {
          this.projectFacde.getTransportScenarioListForRetail$
            .pipe(take(1))
            .subscribe((data: any) => {
              data?.length == 1 && editData[1] == 'manualLocation'
                ? this.setOrigin(null)
                : editData[1] == 'manualLocation'
                ? this.setDestination()
                : this.addTransportDistance();
            });
        }
      );

    this.projectPackRetailForm = this.formBuilder.group({
      transportationDetailForm: this.formBuilder.group({
        Origin: [null],
        destination: [null],
        transportModeForLocation: [null],
        transportModeForDistance: [null],
        distance: [''],
        distanceManulaLocation: [''],
        customScenarioItem: [null],
        palletLoad: [{ value: 0, disabled: true }],
        palletsInTruck: [0],
        loadInTruck: [{ value: 0, disabled: true }],
        percentLoaded: [{ value: 0, disabled: true }],
        palletLoadOrigin: [{ value: 0, disabled: true }],
        palletsInTruckOrigin: [0],
        loadInTruckOrigin: [{ value: 0, disabled: true }],
        percentLoadedOrigin: [{ value: 0, disabled: true }],
      }),
      storageDetailForm: this.formBuilder.group({
        storageProcess: [null],
        storageDays: [this.packReatilData.storageDays || 0, Validators.min(0)],
        productLoss: [this.packReatilData.percentageProductLoss || 0, Validators.min(0)],
        retailLocation: [null, Validators.required],
        cost: [this.packReatilData.cost || 0, Validators.min(0)],
      }),
      productDetailForm: this.formBuilder.group({
        productLoss: [null],
        productLossAssociate: [null],
        secondaryMarket: [
          this.packReatilData?.percentageOfReusedProduct &&
          this.packReatilData?.percentageOfReusedProduct != 0
            ? this.packReatilData?.percentageOfReusedProduct
            : this.secondaryDefaultValue,
        ],
      }),
      eodDetailForm: this.formBuilder.group({
        customEod: [null],
      }),
    });
    this.transportationDetailForm = this.projectPackRetailForm.controls['transportationDetailForm'];
    this.storageDetailForm = this.projectPackRetailForm.controls['storageDetailForm'];
    this.productDetailForm = this.projectPackRetailForm.controls['productDetailForm'];
    this.eodDetailForm = this.projectPackRetailForm.controls['eodDetailForm'];
    this.setFormData();
    this.storageDetailForm.controls['retailLocation'].valueChanges.subscribe((value: any) => {
      this.setStorageDaysValidator(value);
    });
    this.storageDetailForm.controls['productLoss'].valueChanges.subscribe((value: any) => {
      this.productLossValue(value);
    });
    // Initialize validators based on existing product loss value
    this.productLossValue(this.packReatilData.percentageProductLoss || 0);
    this.subscriptionInline = this.projectScenarioRetailDataGridService.isCheckEditEol$.subscribe(
      (inlineData: any) => {
        this.getResetEolList = undefined;
      }
    );
  }

  setStorageDaysValidator(retailLocation: any) {
    const storageDaysControl = this.storageDetailForm.get('storageDays');
    const productLossControl = this.storageDetailForm.get('productLoss');
    if (retailLocation && this.isStorageProcessValue) {
      storageDaysControl.setValidators([Validators.required]);
      productLossControl.setValidators([Validators.max(100)]);
    } else {
      storageDaysControl.clearValidators();
      productLossControl.clearValidators();
    }
    storageDaysControl.updateValueAndValidity();
    productLossControl.updateValueAndValidity();
  }
  async getCustomStorageName() {
    await this.customStorageItems.map((item: any) => {
      if (item.idStr == this.packReatilData?.customStorageId) {
        return (this.customStorageData = item);
      }
    });
  }
  async getStorageName() {
    await this.storageIdentifierItems.map((item: any) => {
      if (item.id == this.packReatilData?.storageIdentifierId) {
        return (this.customStorageData = item);
      }
    });
  }
  async getStorageCountry() {
    await this.regionItems.map((item: any) => {
      if (item.id == this.packReatilData.regionId) {
        this.storageCountryData = item;
      }
    });
  }
  async getProductLoss() {
    await this.productLossWasteDisposalItems.map((item: any) => {
      if (item.id == this.packReatilData?.productLossWasteDisposalId) {
        return (this.productLoassData = item);
      }
    });
  }
  async getProductAccociate() {
    await this.endofLifeIdentifierItems.map((item: any) => {
      if (item.id == this.packReatilData?.endofLifeIdentifierId) {
        return (this.productAccociate = item);
      }
    });
  }
  async getCustomWasteItem() {
    await this.customwasteScenarioItems.map((item: any) => {
      if (item.id == this.packReatilData?.customWasteScenarioId) {
        return (this.customWasteData = item);
      }
    });
  }
  async customScenarioItem() {
    await this.customtransportScenarioItems.map((item: any) => {
      if (item.id == this.packReatilData?.customtransportScenarioId) {
        this.customFreightSelectData = item;
        return (this.customtransportScenarioData = item);
      }
    });
  }
  setFormData() {
    if (!!this.customStorageData) {
      this.isStorageProcessValue = true;
      this.setStorageDaysValidator(this.customStorageData);
    } else {
      this.isStorageProcessValue = false;
    }
    this.secondaryMarketDropdown =
      this.productLoassData?.name == this.secondaryMarketStr ? true : false;
    this.storageDetailForm.patchValue({
      storageProcess: this.customStorageData,
      retailLocation: this.storageCountryData,
    });
    this.productDetailForm.patchValue({
      productLoss: this.productLoassData,
      productLossAssociate: this.productAccociate,
    });
    this.transportationDetailForm.patchValue({
      customScenarioItem: this.customtransportScenarioData,
    });
    this.eodDetailForm.patchValue({ customEod: this.customWasteData });
    this.transportationId = this.packReatilData.transportationId || 2;
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportationId == this.TransportationEnum[index].id;
    });
    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectLocation = true;
        break;
      case 3:
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectDistance = true;
        break;
      case 4:
        this.wholeData[2]['img'] = this.customWhite;
        this.selectCustom = true;
        break;
      default:
        break;
    }
  }

  changeProductLoss(event: any, type: 'clear' | 'change') {
    if (type == 'change' && event?.id) {
      this.secondaryMarketDropdown = event.name == this.secondaryMarketStr ? true : false;
    } else {
      this.secondaryMarketDropdown = false;
    }
  }

  productLossValue(value: number) {
    if (value > 0) {
      this.productDetailForm.controls['productLoss'].setValidators(Validators.required);
      this.productDetailForm.controls['productLossAssociate'].setValidators(Validators.required);
    } else {
      this.productDetailForm.controls['productLoss'].removeValidators(Validators.required);
      this.productDetailForm.controls['productLossAssociate'].removeValidators(Validators.required);
    }
    this.productDetailForm.controls['productLoss'].updateValueAndValidity();
    this.productDetailForm.controls['productLossAssociate'].updateValueAndValidity();
  }

  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.processColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.isCalcByPalletOrigin = false;
    this.isCalcByPallet = false;
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.transportationId = 2;
        this.customTransportList = null;
        this.projectFacde.clearFreightProcess();
        this.projectFacde.getTransportScenarioListForRetail$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.packRetailTransportScenarioManualLocationActions(
                updatedData,
                'reset'
              );
            }
          });
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.transportationId = 3;
        this.customTransportList = null;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue('');
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.setOriginsubmitted = false;
        this.setDestinationsubmitted = false;
        this.projectFacde.clearFreightProcess();
        this.projectFacde.getTransportScenarioListForDistancePackRetail$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.packRetailTransportScenarioActionsFordistance(updatedData, 'reset');
            }
          });
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.isShowDistantField = false;
        this.checkAddCustomFreight = false;
        this.transportationId = 4;
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].clearValidators();
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue('');
        this.transportationDetailForm.controls['distance'].clearValidators();
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }
  onClose() {
    this.modal.close();
    this.projectFacde.clearTotalEolMessage();
    this.projectFacde.clearTransportScenarioForPackRetail();
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchFordis(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  getLastItem() {
    this.projectFacde.getTransportScenarioListForRetail$.pipe(take(1)).subscribe((data: any) => {
      this.lastItem = this.isCheckUpdateDestination
        ? data[data.findIndex((item: any) => item.index === this.projectRetaileditData.index) - 1]
        : data[data?.length - 1];
    });
  }

  changeTransportMode(event: any) {
    if (!!event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
      this.projectService.getTruckMassLoad(event.id).subscribe((res: any) => {
        this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(res.data.maxLoad);
        this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(
          res.data.percenteageMassLoad
        );
        this.maxLoad = res.data.maxLoad;
      });
    }
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.customtransportScenarioItems = res.data;
    });
  }

  async calculateDistance(lastItem?: any) {
    const payload = {
      origin: lastItem.originName,
      destination: this.transportationDetailForm.controls['destination'].value.name,
      destinationId: Number(this.transportationDetailForm.controls['destination'].value.idStr),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.originName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.transportationDetailForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis();
    }
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.originName],
      destinations: [this.transportationDetailForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.transportationDetailForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeTransportModeDistance(event: any) {
    if (!!event.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.projectService.getTruckMassLoad(event.id).subscribe((res: any) => {
        this.transportationDetailForm.controls['loadInTruck'].setValue(res.data.maxLoad);
        this.transportationDetailForm.controls['percentLoaded'].setValue(
          res.data.percenteageMassLoad
        );
        this.maxLoad = res.data.maxLoad;
      });
    }
  }

  changeCustomTransportItem(event: any) {
    this.isShowCustomTransportList = false;
    this.customTransportList = [];
    if (!!event?.id) {
      this.customFreightSelectData = event;
    }
  }

  resetTransport() {
    this.customFreightSelectData = null;
  }
  addCustomFreight() {
    if (!!this.customFreightSelectData) {
      this.checkAddCustomFreight = true;
      this.CustomtransportScenarioId = this.customFreightSelectData.id;
      if (this.customFreightSelectData.isCustomSiteTransport && this.CustomtransportScenarioId) {
        this.CustomtransportScenarioId = this.CustomtransportScenarioId;
        this.projectService
          .GetCustomSiteTransportList(this.CustomtransportScenarioId)
          .subscribe((data: any) => {
            this.customTransportDef =
              this.projectScenarioRetailDataGridService.getCustomTransportItemsList();
            this.isShowCustomTransportList = true;
            this.customTransportList = data;
          });
      }
      if (!this.customFreightSelectData.isCustomSiteTransport && this.CustomtransportScenarioId) {
        this.CustomtransportScenarioId = this.CustomtransportScenarioId;
        this.projectService
          .GetCustomTransportList(this.CustomtransportScenarioId)
          .subscribe((data: any) => {
            this.customTransportDef =
              this.projectScenarioRetailDataGridService.getCustomTransportItemsList();
            this.isShowCustomTransportList = true;
            this.customTransportList = data;
          });
      }
    }
  }
  chnageCustomTruck(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.processColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectScenarioRetailDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
    this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
  }
  changeStorageValue(event: any) {
    this.isCustomStorage = event.target.checked ? true : false;
    this.storageDetailForm.controls['storageProcess'].setValue(null);
  }

  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }

  onSearch(searchValue: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  showPorts(event: any) {
    this.transportationDetailForm.controls['Origin'].setValue(null);
    this.transportationDetailForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  selectEvent(event: any) {
    this.originId = event.idStr;
    this.keywordAuto = '';
    this.selectedCities = [];
  }
  clearStorage() {
    this.storageDetailForm.controls['storageDays'].setValue(0);
    this.storageDetailForm.controls['productLoss'].setValue(0);
    this.storageDetailForm.controls['storageDays'].clearValidators();
    this.storageDetailForm.controls['productLoss'].clearValidators();
    this.storageDetailForm.controls['storageDays'].updateValueAndValidity();
    this.storageDetailForm.controls['productLoss'].updateValueAndValidity();
  }
  checkStorageProcess(event: any) {
    if (event?.id || event?.idStr) {
      this.isStorageProcessValue = true;
      this.setStorageDaysValidator(event);
    }
  }
  getCustomConversionProcessList() {
    this.projectService.getCustomConversionProcessList().subscribe((data: any) => {});
  }
  getCustomTruckList() {
    this.projectService.getPackRetailCustomTruckList().subscribe((data: any) => {
      this.customTruckItems = data.data;
      this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
    });
  }
  getCustomStorageList() {
    this.projectService.getCustomStorageList().subscribe((data: any) => {
      this.customStorageItems = data.data;
      this.storageDetailForm.controls['storageProcess'].setValue(null);
    });
  }

  setOrigin(dataList: any) {
    this.setOriginsubmitted = true;
    if (this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty('name')) {
      this.processColumnDef =
        this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn();
      this.processColumnDef.forEach((column: any) => {
        if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
          column.hide = false;
        } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
          column.hide = true;
        }
      });
      this.transportScenarioData = {
        id: 0,
        originName: this.transportationDetailForm.value.Origin.name,
        distance: '',
        originId: this.originId,
      };
      this.projectFacde.packRetailTransportScenarioManualLocationActions(
        this.transportScenarioData,
        this.isCheckUpdateOrigin ? 'edit' : 'add'
      );
      this.transportationDetailForm.controls['Origin'].reset();
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
    } else {
      return;
    }
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.projectFacde.getTransportScenarioListForRetail$
      .pipe(take(1))
      .subscribe(async (data: any) => {
        const startIndex = data.findIndex(
          (item: any) => item.index === this.projectRetaileditData.index
        ); // Index to start checking after
        if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
          let destinationNextRecord =
            data[
              data.findIndex((item: any) => item.index === this.projectRetaileditData.index) + 1
            ];
          const lastItemNextRecord = this.transportationDetailForm.value.destination;
          try {
            await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
            Object.freeze(destinationNextRecord);
            const objCopy = { ...destinationNextRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            destinationNextRecord = objCopy;
            this.projectFacde.packRetailTransportScenarioManualLocationActions(
              destinationNextRecord,
              'edit'
            );
          } catch (error) {
            // Handle error, e.g., log it or show a user-friendly message.
            console.error('Error:', error);
          }
        }
      });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacde.getTransportScenarioListForRetail$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (!!belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.originName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacde.packRetailTransportScenarioManualLocationActions(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.originName;
      const toCity = this.transportationDetailForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.transportationDetailForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.transportationDetailForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async setDestination() {
    this.setDestinationsubmitted = true;

    if (
      this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty('name') &&
      this.transportationDetailForm.controls['transportModeForLocation'].value
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.transportationDetailForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        (this.transportationDetailForm.controls['destination']?.value?.name?.includes('Port') &&
          (this.lastItem?.originName?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        !!this.transportModeId && (await this.calculateDistance(this.lastItem));
      }
      if (this.messageType != 1) {
        if (
          (this.transportationDetailForm.value.destination?.idStr ||
            this.transportationDetailForm.value.destination?.originId) ==
            this.projectRetaileditData?.originId &&
          this.transportModeId == this.projectRetaileditData?.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.projectRetaileditData?.originId &&
          this.transportationDetailForm.value.destination?.idStr !=
            this.projectRetaileditData?.originId &&
          this.changeNextRecordDistance();
        this.destinationData = {};
        this.destinationData['id'] = 0;
        if (this.isCheckUpdateDestination) {
          this.destinationData['index'] = this.projectRetaileditData.index;
        }
        this.destinationData['isCustomTruck'] = this.isCustomTruck;

        this.isCustomTruck
          ? (this.destinationData['customTruckId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectRetaileditData.transportModeId)
          : (this.destinationData['transportModeId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectRetaileditData.transportModeId);
        this.destinationData['transportModeName'] =
          this.transportationDetailForm.value.transportModeForLocation.name;
        const newManualLocationDisatance =
          this.transportationDetailForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.projectRetaileditData?.distance == 'string' &&
          !!this.projectRetaileditData?.distance
            ? this.projectRetaileditData?.distance?.substring(
                this.projectRetaileditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);

        if (this.transportModeName?.toLowerCase() == commonEnum.shipName) {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }

        this.destinationData['originId'] =
          this.transportationDetailForm.value.destination.idStr ||
          this.transportationDetailForm.value.destination.originId;
        this.destinationData['idStr'] = this.destinationData['originId'];
        this.destinationData['originName'] = this.transportationDetailForm.value.destination.name;
        this.destinationData['transportationId'] = this.transportationId;
        this.destinationData['isOrigin'] = this.isCheckUpdateDestination
          ? this.projectRetaileditData.isOrigin
          : true;
        this.destinationData['isPalletLoad'] = this.isCalcByPalletOrigin;
        (this.destinationData['persanteageMassLoad'] =
          this.transportationDetailForm.controls['percentLoadedOrigin']?.value || 0),
          (this.destinationData['palletLoad'] =
            this.transportationDetailForm.controls['palletLoadOrigin']?.value);
        this.destinationData['palletInTruck'] =
          this.transportationDetailForm.controls['palletsInTruckOrigin']?.value;
        this.destinationData['loadInTruck'] =
          this.transportationDetailForm.controls['loadInTruckOrigin']?.value;
        this.destinationData['maxLoad'] = this.maxLoad;
        this.setDestinationsubmitted = false;
        this.projectFacde.packRetailTransportScenarioManualLocationActions(
          this.destinationData,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(0);
        this.transportationDetailForm.controls['palletLoadOrigin'].setValue(0);
        this.transportationDetailForm.controls['palletsInTruckOrigin'].setValue(0);
        this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(0);
        this.setOriginsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.messageType = 0;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.transportationDetailForm.controls['transportModeForLocation'].reset();
        this.messageType = 0;
        this.setDestinationsubmitted = false;
      } else {
        this.setDestinationsubmitted = true;
      }
    }
  }

  addTransportDistance() {
    this.setManualDistanceSubmitted = true;
    if (
      this.transportationDetailForm.controls['transportModeForDistance'].value &&
      this.transportationDetailForm.controls['distance'].value
    ) {
      this.transportScenarioDataForDistance = {};
      this.transportScenarioDataForDistance['id'] = 0;
      if (this.isCheckEditManudalDist) {
        this.transportScenarioDataForDistance['index'] =
          this.projectRetaileditManualDistanceData.index;
      }
      this.transportScenarioDataForDistance['isCustomTruck'] = this.isCustomTruck;
      this.isCustomTruck
        ? (this.transportScenarioDataForDistance['customTruckId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectRetaileditManualDistanceData.transportModeId)
        : (this.transportScenarioDataForDistance['transportModeId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectRetaileditManualDistanceData.transportModeId);
      this.transportScenarioDataForDistance['transportModeName'] =
        this.transportationDetailForm.value.transportModeForDistance.name;
      this.transportScenarioDataForDistance['distance'] =
        this.transportationDetailForm.value.distance;
      this.transportScenarioDataForDistance['isPalletLoad'] = this.isCalcByPallet;
      (this.transportScenarioDataForDistance['persanteageMassLoad'] =
        this.transportationDetailForm.controls['percentLoaded'].value || 0),
        (this.transportScenarioDataForDistance['palletLoad'] =
          this.transportationDetailForm.controls['palletLoad'].value);
      this.transportScenarioDataForDistance['palletInTruck'] =
        this.transportationDetailForm.controls['palletsInTruck'].value;
      this.transportScenarioDataForDistance['loadInTruck'] =
        this.transportationDetailForm.controls['loadInTruck'].value;
      this.transportScenarioDataForDistance['maxLoad'] = this.maxLoad;
      this.projectFacde.packRetailTransportScenarioActionsFordistance(
        this.transportScenarioDataForDistance,
        this.isCheckEditManudalDist ? 'edit' : 'add'
      );
      this.setManualDistanceSubmitted = false;
      this.isCheckEditManudalDist = false;
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
      this.transportationDetailForm.controls['distance'].setValue(null);
      this.transportationDetailForm.controls['percentLoaded'].setValue(0);
      this.transportationDetailForm.controls['palletsInTruck'].setValue(0);
      this.transportationDetailForm.controls['palletLoad'].setValue(0);
      this.transportationDetailForm.controls['loadInTruck'].setValue(0);
    }
  }

  calcByPallet(event: any) {
    this.isCalcByPallet = !!event.target.checked ? true : false;
    !!this.isCalcByPallet
      ? this.projectService
          .getLoadPerPallet(this.scenarioId, this.projectId)
          .subscribe((res: any) => {
            this.transportationDetailForm.controls['palletLoad'].setValue(res.data?.loadInPallet);
          })
      : '';
  }

  getWasteScenarioList() {
    this.projectService.getPackRetailCustomWasteScenarioList().subscribe((data: any) => {
      this.customwasteScenarioItems = data.data;
    });
  }

  calcByPalletOrigin(event: any) {
    this.isCalcByPalletOrigin = !!event.target.checked ? true : false;
    !!this.isCalcByPalletOrigin
      ? this.projectService
          .getLoadPerPallet(this.scenarioId, this.projectId)
          .subscribe((res: any) => {
            this.transportationDetailForm.controls['palletLoadOrigin'].setValue(
              res.data?.loadInPallet
            );
          })
      : '';
  }

  LoadInTruckCalculation() {
    const total =
      this.transportationDetailForm.controls['palletLoad'].value *
      this.transportationDetailForm.controls['palletsInTruck'].value;
    if (total > this.maxLoad) {
      this.transportationDetailForm.controls['loadInTruck'].setValue(this.maxLoad);
      this.toaster.warning(
        'The suggested load is more than the capacity of the truck, so the truck load will be set to 100% capacity. Consider revising the load data.'
      );
    } else {
      this.transportationDetailForm.controls['loadInTruck'].setValue(Math.round(total * 1e9) / 1e9);
    }
    let percentageMassLoad =
      (this.transportationDetailForm.controls['loadInTruck'].value / this.maxLoad) * 100;
    if (isNaN(percentageMassLoad) || percentageMassLoad == Infinity) {
      percentageMassLoad = 0;
      this.transportationDetailForm.controls['percentLoaded'].setValue(0);
    } else {
      this.transportationDetailForm.controls['percentLoaded'].setValue(
        Math.round(percentageMassLoad * 1e9) / 1e9
      );
    }
  }

  LoadInTruckCalculationOrigin() {
    const total =
      this.transportationDetailForm.controls['palletLoadOrigin'].value *
      this.transportationDetailForm.controls['palletsInTruckOrigin'].value;
    if (total > this.maxLoad) {
      this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(this.maxLoad);
      this.toaster.warning(
        'The suggested load is more than the capacity of the truck, so the truck load will be set to 100% capacity. Consider revising the load data.'
      );
    } else {
      this.transportationDetailForm.controls['loadInTruckOrigin'].setValue(Math.round(total * 1e9) / 1e9);
    }
    let percentageMassLoad =
      (this.transportationDetailForm.controls['loadInTruckOrigin'].value / this.maxLoad) * 100;
    if (isNaN(percentageMassLoad) || percentageMassLoad == Infinity) {
      percentageMassLoad = 0;
      this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(0);
    } else {
      this.transportationDetailForm.controls['percentLoadedOrigin'].setValue(
        Math.round(percentageMassLoad * 1e9) / 1e9
      );
    }
  }

  inlineDataEditEvent(record: any) {
    this.projectFacde.packRetailTransportScenarioManualLocationActions(record[1], 'edit');
  }

  getEolList(event: any) {
    if (event.id) {
      this.customWasteScenarioId = event.id;
      const payload = {
        storageId: 0,
        packagescenarioId: this.packReatilData.packageScenarioId,
        countryId: this.packReatilData.regionId,
        customWasteScenarioId: event.id || this.packReatilData.customWasteScenarioId || 0,
        storageTypeId: this.packReatilData.storageTypeId,
        isCreate: this.modalLabel.toLowerCase() == 'add retail' ? true : false,
      };
      this.projectService
        .getEolLifeList(
          payload.storageId,
          payload.packagescenarioId,
          payload.countryId,
          payload.customWasteScenarioId,
          payload.storageTypeId,
          payload.isCreate
        )
        .subscribe((data: any) => {
          if (data.messageType == 0) {
            this.getResetEolList = undefined;
            this.projectFacde.addEolViewModalDataChange(data.data);
          }
        });
    }
  }

  chnageCustomEol(event: any) {
    this.isCustomEndofLife = event.target.checked ? true : false;
    this.eodDetailForm.controls['customEod'].setValue(null);
  }

  onReset() {
    this.projectFacde.getresetEolList$.pipe(first()).subscribe((data: any) => {
      this.getResetEolList = data;
      this.projectFacde.addEolViewModalData(this.getResetEolList);
    });
    this.eodDetailForm.controls['customEod'].setValue(null);
    this.projectFacde.clearTotalEolMessage();
  }
  saveData(
    distanceTransportationItems: any,
    locationTransportationItems: any,
    eOLListViewModels: any,
    rowValue: any
  ) {
    this.finalSubmit = true;
    this.rowValue = rowValue.rowValue;
    if (this.selectLocation) {
      locationTransportationItems = locationTransportationItems;
      distanceTransportationItems = [];
      this.CustomtransportScenarioId = undefined;
    } else if (this.selectDistance) {
      distanceTransportationItems = distanceTransportationItems;
      locationTransportationItems = [];
      this.CustomtransportScenarioId = undefined;
    } else {
      locationTransportationItems = [];
      distanceTransportationItems = [];
    }
    if (this.projectPackRetailForm.valid) {
      locationTransportationItems = locationTransportationItems.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        }
        return item;
      });

      if (!!distanceTransportationItems) {
        distanceTransportationItems = distanceTransportationItems.map((item: any) => {
          return {
            ...item,
            unit: 'km',
          };
        });
      }

      const mainPayload: any = {};
      mainPayload['id'] = this.packReatilData.id || 0;
      mainPayload['storageTypeId'] =
        this.pathName == 'retail-list'
          ? this.StorageTypeEnum.Retail
          : this.StorageTypeEnum.Consumer;
      mainPayload['isCustomEndofLife'] = this.isCustomEndofLife;
      mainPayload['customWasteScenarioId'] =
        this.customWasteScenarioId || this.packReatilData.customWasteScenarioId;
      mainPayload['regionId'] = this.storageDetailForm.value.retailLocation.id;
      mainPayload['percentageProductLoss'] = this.storageDetailForm.value.productLoss;
      mainPayload['storageDays'] = this.storageDetailForm.value.storageDays;
      mainPayload['cost'] = this.storageDetailForm.value.cost;
      mainPayload['transportationId'] = this.transportationId;
      mainPayload['scenarioId'] = this.packReatilData.scenarioId;
      mainPayload['isCustomStorage'] = this.isCustomStorage;
      mainPayload['distanceTransportationItems'] = distanceTransportationItems;
      mainPayload['locationTransportationItems'] = locationTransportationItems;
      mainPayload['customtransportScenarioId'] = this.checkAddCustomFreight
        ? this.CustomtransportScenarioId
        : undefined;
      mainPayload['packagescenarioId'] = this.packReatilData.packageScenarioId;
      mainPayload['EOLListItem'] = eOLListViewModels;
      mainPayload['endofLifeIdentifierId'] =
        this.productDetailForm.value.productLossAssociate?.id ||
        this.packReatilData.endofLifeIdentifierId;
      mainPayload['productLossWasteDisposalId'] = this.productDetailForm.value.productLoss?.id;
      this.isCustomStorage
        ? (mainPayload['customStorageId'] = this.storageDetailForm.value.storageProcess?.idStr)
        : (mainPayload['storageIdentifierId'] = this.storageDetailForm.value.storageProcess?.id);
      if (this.secondaryMarketDropdown) {
        mainPayload['percentageOfReusedProduct'] =
          this.productDetailForm.controls['secondaryMarket'].value?.name ||
          this.productDetailForm.controls['secondaryMarket'].value;
      } else {
        mainPayload['percentageOfReusedProduct'] = 0;
      }
      this.saveNewMyProjectPackRetailEvent.emit(mainPayload);
      this.checkAddCustomFreight = false;
      this.modal.close();
      this.projectFacde.clearTransportScenarioForPackRetail();
      this.projectFacde.clearTotalEolMessage();
    }
  }

  ngOnDestroy() {
    this.projectFacde.clearaddTransportScenarioForPackMaterialForConversion();
    this.searchSubject.complete();
  }
}
